import SectionLabel, { Sparkle } from './SectionLabel';

const futureCards = [
  {
    title: 'EDUCATION',
    body: "The music business is often an 'unknown' territory for newcomers. We are developing courses designed to help artists navigate the industry's complexities -- covering the practical, legal, and financial knowledge rarely taught in schools.",
  },
  {
    title: 'TECHNOLOGY',
    body: 'We are currently developing a platform designed to connect the creative industry like never before. It will be a dedicated space where artists, professionals, and businesses can find each other and collaborate seamlessly.',
  },
];

const MissionFutureSection = () => {
  return (
    <section className="bg-[#0D0D0D] pt-[64px] md:pt-[96px] lg:pt-[127px] pb-[64px] md:pb-[96px] lg:pb-[122px]">
      <div className="max-w-[1108px] mx-auto px-5 md:px-8 lg:px-0">
        {/* Our mission */}
        <SectionLabel>OUR MISSION</SectionLabel>
        <h2 className="mt-[16px] md:mt-[22px] text-center text-white font-bold leading-[1.15] text-[28px] sm:text-[34px] md:text-[40px] lg:text-[54px]">
          Bringing transparency and
          <br className="hidden sm:block" /> structure to the industry
        </h2>
        <p className="mt-[24px] md:mt-[34px] mx-auto max-w-[908px] text-center text-white/60 text-[15px] md:text-[17px] lg:text-[20px] leading-[1.62]">
          Our mission is to bring transparency and structure to an unorganized industry. We aim to
          equip artists with professional-grade resources, ensuring that quality and business acumen
          are never the barriers to their success. Whether it's an independent release or a major
          label campaign, our goal is to deliver excellence that cuts through the noise.
        </p>

        {/* The future */}
        <div className="mt-[80px] md:mt-[160px] lg:mt-[260px]">
          <SectionLabel>THE FUTURE</SectionLabel>
          <h2 className="mt-[16px] md:mt-[22px] text-center text-white font-bold leading-[1.12] text-[28px] sm:text-[34px] md:text-[40px] lg:text-[54px]">
            Expanding our ecosystem
          </h2>

          <div className="mt-[32px] md:mt-[48px] lg:mt-[66px] grid grid-cols-1 md:grid-cols-2 gap-[16px] md:gap-[32px]">
            {futureCards.map((card) => (
              <div
                key={card.title}
                className="relative overflow-hidden rounded-[12px] border border-white/[0.08] bg-[#141414] p-[28px] md:p-[38px] lg:p-[48px]"
              >
                {/* soft warm glow in the top-right corner, as per design */}
                <div
                  className="pointer-events-none absolute -top-[70px] -right-[50px] w-[320px] h-[250px] opacity-70"
                  style={{
                    background:
                      'radial-gradient(circle at 70% 25%, rgba(255,128,0,0.18) 0%, rgba(255,128,0,0.06) 40%, rgba(255,128,0,0) 70%)',
                  }}
                />
                <div className="relative">
                  <Sparkle className="w-[19px] h-[19px] text-white" />
                  <h3 className="mt-[26px] md:mt-[36px] lg:mt-[46px] text-white font-bold uppercase text-[20px] md:text-[24px] lg:text-[30px] leading-none">
                    {card.title}
                  </h3>
                  <p className="mt-[14px] md:mt-[20px] lg:mt-[26px] text-white/55 text-[14px] md:text-[15px] lg:text-[16px] leading-[1.68] max-w-[440px]">
                    {card.body}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default MissionFutureSection;
